import React from "react";
import { ThemeProvider } from "./theme";

/**
 * Shared `wrapRootElement` used by both gatsby-browser.js and gatsby-ssr.js so
 * the ThemeProvider wraps the app identically during SSR and hydration.
 */
export const wrapRootElement = ({ element }) => (
  <ThemeProvider>{element}</ThemeProvider>
);
